export const services = [
  { name: "Пластмассовая коронка", price: 5000 },
  { name: "Провизорная коронка", price: 1000 },
  { name: "Лабораторная штифтовкладка", price: 3000 },
  { name: "Лабораторная штифтовкладка 2-х корневая", price: 3500 },
  { name: "Лабораторная штифтовкладка 3-х корневая", price: 4000 },
  { name: "Лабораторная штифтовкладка разборная", price: 5000 },
  {
    name: "Коронка металлокерамическая. зуб металлокерамический в мотовидном протезе",
    price: 10000,
  },
  { name: "Коронка металлокерамическая одиночная", price: 14000 },
  {
    name: "Коронка. зуб металлокерамическая на имплантате",
    price: "*",
  },
  { name: "Коронка штампованная .зуб фасетка", price: 5000 },
  { name: "Коронка штампованная комбинированная", price: 6000 },
  { name: "Коронка цельнолитая одиночная", price: 10000 },
  { name: "Коронка цельнолитая .зуб в мостовидном протезе", price: 7000 },
  { name: "Полный съемный протез на одну челюсть", price: 25000 },
  { name: "Полный съемный протез на верхнюю и нижнюю челюсти", price: 50000 },
  { name: "Частичный съемный протез на одну челюсть", price: 25000 },
  {
    name: "Частичный съемный полиамидный протез на одну челюсть",
    price: 25000,
  },
  {
    name: "Бюгельный протез с гнутыми проволочными кламмерами на одну челюсть",
    price: 40000,
  },
  { name: "Безметалловая керамика за единицу", price: 15000 },
  { name: "Напыление .стоимость за единицу", price: 200 },
  { name: "Починка съемного протеза", price: "*" },
  { name: "Консультация врача с оформлением справки", price: 250 },
  { name: "Одноразовый гигиенический набор", price: 300 },
  { name: "Снятие коронки цельнолитой металлокерамической", price: 1000 },
  { name: "Снятие коронки штампованной", price: 700 },
  { name: "Анестезия", price: 200 },
  { name: "Рентгенологическое исследование 1 снимок", price: 200 },
  {
    name: "Фиксация коронки ,штифтовкладки и др. изготовленных сторонней организацией .за единицу",
    price: 1500,
  },
  {
    name: "Коррекция Съемного протеза по истечении срока гарантии или изготовленного сторонней организацией",
    price: 1500,
  },
  {
    name: "Временная пломба (Кависил ,Глассин или светоотверждаемая)",
    price: "*",
  },
  {
    name: "Проведение профессиональной гигиены полости рта ( комплексное)",
    price: 3000,
  },
  {
    name: "Проведение профессиональной гигиены полости рта (один зуб) с аэрфлоу",
    price: 200,
  },
  { name: "Покрытие зубов фторосодержащим средством ( 1 зуб)", price: 100 },
  { name: "Наложение коффердама", price: 500 },
  {
    name: "Лечение поверхностного кариеса с использованием светоотверждаемого композита",
    price: 1600,
  },
  {
    name: "Лечение среднего кариеса 1. V Класса с использованием светоотверждаемого композита",
    price: 1800,
  },
  {
    name: "Лечение среднего кариеса II III  IV с использованием светоотверждаемого композита",
    price: 2000,
  },
  {
    name: "Лечение глубокого кариеса  I  V классов с использованием светоотражаемого композита",
    price: 2100,
  },
  {
    name: "Лечение глубокого кариеса II  III  IV  класса с использованием светоотверждаемого композита",
    price: 2200,
  },
  { name: "Восстановление зуба разрушенного более чем на 50%", price: 2400 },
  { name: "Распломбирование 1 коренного канала под штифт", price: 600 },
  { name: "Фиксация стекловолоконного штифта в корневой канал", price: 700 },
  { name: "Лечение пульпита 1- корневого зуба в одно посещение", price: 5000 },
  { name: "Лечение пульпита 2 – корневого зуба в одно посещение", price: 6700 },
  { name: "Лечение пульпита 3- корневого зуба в одно посещение", price: 8400 },
  {
    name: "Лечение пульпита 1,2,3- корневого зуба в три посещения : 1 посещение(наложение девитализирующей повязки)",
    price: 1050,
  },
  {
    name: "Лечение пульпита 1-корневогозуба в три посещения .2 посещение (  препарирование и пломбирование каналов)",
    price: 2600,
  },
  {
    name: "Лечение пульпита 1.2.3.-корневого зуба в 3 посещения ( постановка пломбы)",
    price: 2200,
  },
  {
    name: "Лечение пульпита 2-х корневого зуба в три посещения: 2 посещение (  препарирование и пломбирование каналов)",
    price: 4300,
  },
  {
    name: "Лечение пульпита 3-х корневого зуба в 3 посещения 2 посещение (препарирование и пломбирование каналов)",
    price: 6000,
  },
  {
    name: "Препарирование и медикаментозная обработка одного корневого канала с введением лекарственных средств.",
    price: 1500,
  },
  {
    name: "Медикаментозная обработка одного коренного канала",
    price: 500,
  },
  {
    name: "Пломбирование Одного корневого канала",
    price: 700,
  },
  {
    name: "Распломбирование 1 корневого канала пломбированного фосфат -Цементом",
    price: 1200,
  },
  {
    name: "Распломбирование 1 корневого канала пломбированного пастой, гуттаперчей.",
    price: 700,
  },
  {
    name: "Лечение пародонта : шинирование 1 зуба",
    price: 1000,
  },
  {
    name: "Лечение пародонта : наложение шва.",
    price: 500,
  },
  {
    name: "Извлечение инородного тела из корневого канала",
    price: 1050,
  },
  {
    name: "Дополнительный комплекс при санации полости рта 1.",
    price: 1500,
  },
  {
    name: "Дополнительный комплекс при санации полости рта 2.",
    price: 2000,
  },
  {
    name: "Винир композитный",
    price: 3200,
  },
];
